<div class="technical-production-badge-scan">
    <div class="technical-production-badge-scan__card">
        <h1 class="technical-production-badge-scan__title">
            {{ 'technicalProductionScan.title' | translate }}
        </h1>

        <p class="technical-production-badge-scan__message">
            {{ 'technicalProductionScan.message' | translate }}
        </p>

        <app-alert
            *ngIf="errorMessage"
            type="error"
            [responsive]="true"
            [message]="errorMessage">
        </app-alert>

        <div class="technical-production-badge-scan__scanner">
            <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
            <app-badge-scanner *ngIf="!isLoading" (scan)="onScan($event)"></app-badge-scanner>
        </div>
    </div>
</div>
